
import PRM from "@/core/PermissionConstants";
export default {
    path: "/app/revalidacion/pendientes",
    name: "REVALIDATION-PENDING",
    component: () => import("@/app/views/InterpretationView.vue"),
    componentDialog: () => import("@/app/views/crud/CrudDialogView.vue"),
    meta: {
        service: () => import("@/app/services/InterpretationService"),
        table: () => import("@/app/components/interpretation/revalidationPending/InterpretationRevalidationPendingTable.vue"),
        form: () => import("@/app/components/interpretation/revalidationPending/InterpretationRevalidationPendingForm.vue"),
        serviceDialog: () => import("@/app/services/TemplateDialogService"),
        tableDialog: () => import("@/app/components/dialog/templateDialog/TemplateDialogTable.vue"),
        formDialog: () => import("@/app/components/dialog/templateDialog/TemplateDialogForm.vue"),
        header: {
        icono: "mdi-clipboard-text-outline",
        texto: "Pendientes por interpretar",
        textNew: "Interpretando",
        textEdit: "",
      },  
      headerDialog: {
        icono: "mdi-wrench",
        texto: "Plantilla",
        textNew: "Nueva plantilla",
        textEdit: "Editar plantilla",
      },
      pm: true,
      //prm: PRM.MODULE_IMAGE_INTERPRETATION_PENDING,
      requireAuth: true,
      filterDate: true,
      hideButtonAdd: true,
      addButtonText: "GUARDAR INTERPRETACIÓN",
      filterModality: true,
      cancelationModal: true,
      generatePDFModal: true,
      hideButtonAddDialog: false,
      addButtonTextDialog: "AGREGAR PLANTILLA",      
    },
  };
  